// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__1MD0+","row":"skills_row__qb1jT"};